const Marquee = {
  start(root, { speed = 30, pauseOnHover = true } = {}) {
    if (!root || root.dataset.marqueeReady === "true") return;

    const list = root.querySelector("[data-marquee-list]");
    if (!list || !list.children.length) return;

    const originals = [...list.children].map((node) => node.cloneNode(true));
    const track = document.createElement("div");
    track.className = "marquee-track";
    list.parentNode.insertBefore(track, list);
    track.appendChild(list);

    const clone = list.cloneNode(false);
    clone.setAttribute("aria-hidden", "true");
    track.appendChild(clone);

    root.dataset.marqueeReady = "true";
    root.classList.add("is-marquee");
    if (pauseOnHover) root.classList.add("is-marquee-pause");

    let lastWidth = 0;

    const layout = () => {
      const width = root.clientWidth;
      if (!width || width === lastWidth) return;
      lastWidth = width;

      const gap = getComputedStyle(list).gap;
      const endGap = !gap || gap === "normal" ? "0px" : gap;

      list.replaceChildren(...originals.map((node) => node.cloneNode(true)));
      list.style.paddingInlineEnd = endGap;

      let guard = 0;
      while (list.scrollWidth < width && guard < 12) {
        originals.forEach((node) => list.appendChild(node.cloneNode(true)));
        guard += 1;
      }

      clone.replaceChildren(...[...list.childNodes].map((node) => node.cloneNode(true)));
      clone.style.paddingInlineEnd = endGap;

      const distance = list.getBoundingClientRect().width;
      track.style.animationDuration = `${Math.max(distance / speed, 1)}s`;
    };

    layout();

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(() => layout());
      observer.observe(root);
    }
  },
};

if (!customElements.get("marquee-string")) {
  class MarqueeString extends HTMLElement {
    constructor() {
      super();
      this._intervals = [];
      this._serverEndMs = null;
      this._pageLoadTimeMs = Date.now();
    }

    connectedCallback() {
      this.initMarquee();
    }

    disconnectedCallback() {
      this._intervals.forEach((id) => clearInterval(id));
    }

    initMarquee() {
      const serverEndAttr = this.getAttribute("data-server-end") || this.dataset.serverEnd;
      if (serverEndAttr) {
        const serverEndSec = Number(serverEndAttr);
        if (!Number.isNaN(serverEndSec)) {
          this._serverEndMs = serverEndSec * 1000;
        }
      }

      const useServerAttr = this.getAttribute("data-use-server-time") || this.dataset.useServerTime;
      if (useServerAttr === undefined || useServerAttr === null || String(useServerAttr) === "") {
        this._useServerTime = true;
      } else {
        this._useServerTime = String(useServerAttr).toLowerCase() === "true";
      }

      const timers = this.querySelectorAll(".countdown-item");

      timers.forEach((el) => {
        this.updateCountDown(el);
        const id = setInterval(() => this.updateCountDown(el), 1000);
        this._intervals.push(id);
      });

      const enableMarqueeAttr = this.getAttribute("data-enable-marquee") || this.dataset.enableMarquee;
      const enableMarquee = String(enableMarqueeAttr).toLowerCase() === "true";

      if (!enableMarquee) return;

      Marquee.start(this, { speed: 30, pauseOnHover: true });
    }

    updateCountDown(el) {
      // determine whether this block should repeat daily
      const repeatAttr = String(el.getAttribute('data-repeat') || el.dataset.repeat || '').toLowerCase();
      const isRepeat = repeatAttr === 'true';

      let endMs;
      if (isRepeat && this._serverEndMs && this._useServerTime) {
        // recompute server end-of-day dynamically each second so it auto-resets at midnight
        const now = Date.now();
        const millisecondsElapsed = now - this._pageLoadTimeMs;
        const secondsRemainingToday = Math.floor((this._serverEndMs - this._pageLoadTimeMs) / 1000) - Math.floor(millisecondsElapsed / 1000);
        
        if (secondsRemainingToday <= 0) {
          // midnight has passed, use client's end-of-day for new day (or wait for page reload for fresh server timestamp)
          const clientNow = new Date();
          endMs = new Date(
            clientNow.getFullYear(),
            clientNow.getMonth(),
            clientNow.getDate(),
            23,
            59,
            59,
            999
          ).getTime();
        } else {
          endMs = this._serverEndMs;
        }
      } else if (isRepeat) {
        // fallback: client's end of day
        const serverNow = new Date();
        endMs = new Date(
          serverNow.getFullYear(),
          serverNow.getMonth(),
          serverNow.getDate(),
          23,
          59,
          59,
          999
        ).getTime();
      } else {
        endMs = new Date(el.dataset.end).getTime();
      }

      const nowMs = Date.now();
      const diff = endMs - nowMs;

      if (diff <= 0) {
        el.querySelector(".timer").innerHTML = "00H : 00M : 00S";
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);

      el.querySelector(".timer").innerHTML =
        `${String(hours).padStart(2, "0")}H : ` +
        `${String(mins).padStart(2, "0")}M : ` +
        `${String(secs).padStart(2, "0")}S`;
    }
  }

  customElements.define("marquee-string", MarqueeString);
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-marquee]").forEach((root) => {
    Marquee.start(root, { speed: Number(root.dataset.marqueeSpeed) || 30 });
  });
});
